<div class="modal-container">
  <span class="col-2 d-flex cross-container close-button">
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button pointer-cursor"
      (click)="closeDialog()"
    />
  </span>

  <div class="resend-invitation-content">
    <h2 class="resend-invitation-title">{{ "Resend_Invitaion" | translate }}</h2>
    <p class="resend-invitation-message">
      {{ "INVITATION_RESENT_TO_EMAIL" | translate }}<br />
      <strong class="resend-invitation-email">{{ email }}</strong>
    </p>
  </div>

  <div class="buttons-wrapper">
    <button
      class="btn btn-danger px-3 w-100 resend-invitation-btn"
      (click)="resend()"
    >
      {{ "RESEND_INVITATION" | translate }}
    </button>
    <button class="cancel-btn" (click)="cancel()">{{ "CANCEL" | translate }}</button>
  </div>
</div>
